export default "__VITE_ASSET__SgwMAiD1__"